import React, { useMemo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import qs from 'querystring';
import { isArray } from 'lodash';

import { UnidataTable, Table } from '~/components';
import { t } from '~/helpers';
import { recordFiltering, findData } from '~/store/modules/vazaoPosto/actions';
import api from '~/services/api';

import * as S from './styles';
import Form from './Form';

export default function PostoVazao() {
  const redux = useSelector((state) => state.vazaoPosto);

  const [beaks, setBeaks] = useState([]);

  const title = useMemo(() => 'Cadastro Vazão Posto', []);
  const header = useMemo(
    () => [
      { id: 'post_cod_posto', label: 'Cód. Unidata', align: 'center' },
      { id: 'post_desc', label: 'Descrição' },
      { id: 'pova_vazao_maxima', label: 'Vazão Máxima (L/min)' },
      {
        id: 'post_st_reg',
        label: 'Ativo',
        align: 'center',
        formatted: (value) => (value === 'S' ? 'Sim' : 'Não'),
      },
    ],
    []
  );
  const headerBeak = useMemo(
    () => [
      { id: 'bico_cod_bico', label: 'Bico', align: 'center' },
      { id: 'pobi_vazao_maxima', label: 'Vazão Máxima (L/min)' },
    ],
    []
  );

  const handleGetAPIBeaks = useCallback(async ({ post_cod_posto }) => {
    try {
      setBeaks([]);

      if (post_cod_posto) {
        const { data } = await api.get('vazaoposto/bicos', {
          params: {
            wherefield: ['post_cod_posto'],
            valuewherefield: [post_cod_posto],
            typewherefield: ['EQUALS'],
            pagesize: 9999,
          },
          paramsSerializer: (p) => qs.stringify(p),
        });

        setBeaks(data.items);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  return (
    <S.Wrapper>
      <UnidataTable
        fixed
        dense
        header={header}
        read={recordFiltering}
        find={findData}
        redux={redux}
        title={title}
        form={Form}
        onRow={handleGetAPIBeaks}
        keys={['post_cod_posto']}
        detach="desc_num_doc"
        maxHeight="calc(100vh - 50rem)"
        create={false}
        delete={false}
      />

      <Table
        cells={headerBeak}
        data={beaks}
        loading={redux.loading}
        size="small"
      />
    </S.Wrapper>
  );
}
